import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  ASSETS_ALL_ROLES,
  ROUTE_ASSETS_MONTHLY_CHARGES_REPORT,
} from "../../SharedModule/utils/constants";
import { Spinner } from "../../SharedModule/components/Spinner";
import { setActiveTab } from "../../SharedModule/redux/reducers/uiShared.reducer";
import { verifyModuleAccess } from "../../SharedModule/utils/accessUtils";
import { ForbiddenPage } from "../../SharedModule/pages/ForbiddenPage";
import {
  selectAuth,
  selectUserRoles,
} from "../../SharedModule/redux/reducers/auth.reducer";
import { getHostUrl } from "../../ProductsModule/utils/reportsUtils";
import { TelerikReport } from "../../SharedModule/components/TelerikReport";

export const MonthlyChargesReportPage = () => {
  const auth = useSelector(selectAuth);
  let parameters = {
    HostUrl: getHostUrl(),
    Auth: auth.accessToken,
  };
  const dispatch = useDispatch();

  const { userRolesList, rolesLoaded } = useSelector(selectUserRoles);

  useEffect(() => {
    document.title = "The Hub - Monthly Charges by Cost Center Report";
    dispatch(setActiveTab(ROUTE_ASSETS_MONTHLY_CHARGES_REPORT));
  }, []);

  return (
    <>
      {!rolesLoaded && (
        <Spinner
          style={{
            marginLeft: "50%",
            marginTop: "5%",
          }}
        />
      )}
      {rolesLoaded &&
        !verifyModuleAccess(true, ASSETS_ALL_ROLES, userRolesList) && (
          <ForbiddenPage />
        )}

      {rolesLoaded &&
        verifyModuleAccess(true, ASSETS_ALL_ROLES, userRolesList) && (
          <TelerikReport
            title="Monthly Charges by Cost Center"
            reportName="MonthlyChargesByCostCenter.trdp"
            parameters={parameters}
            parametersAreaVisible={false}
          />
        )}
    </>
  );
};
